import React from 'react';
import Countries from 'countries-api';
import {
    Card, Button, CardImg, CardTitle, CardText, CardDeck,
    CardSubtitle, CardBody
} from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import logoImg from '../img/logo.png';
import ReactTable from "react-table";
import "react-table/react-table.css";
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';
import _ from 'lodash';

import '../styles/sideProfile.scss';
import '../styles/schedule.scss';
import {request, update} from '../modules/actions/request';

import Pagination from '../components/Pagination';
import ScheduleCard from '../components/Card';

class History extends React.Component {
    constructor(props) {
        super(props);

        this.state={
            allCountries: [],
            currentCountries: [],

            allSchedules:[],
            currentSchedules: [],

            currentPage: null,
            totalPages: null,
        }

        // this.showUserInfo = this.showUserInfo.bind(this);
        this.getAcceptList = this.getAcceptList.bind(this);
    }

    componentDidMount() {
        const { data: allCountries = [] } = Countries.findAll();
        // console.log('data?', data);
        this.setState({ allCountries });
        // console.log("all cou", this.state.allCountries); // array empty
        // console.log("what is countries", Countries.findAll());
        // console.log("Countries itself", Countries);

        this.showUserInfo();
        // const { allSchedules } = [];
        // this.setState({ allSchedules });
    }

    onPageChanged = data => {
        // console.log("show data",data);
        const { allCountries, allSchedules } = this.state;
        // console.log("know state", this.state);
        // console.log("all countries???", allCountries); // now it shows all countries
        // console.log("all schedules???", allSchedules);
        // const { allSchedules } = this.state;


        const { currentPage, totalPages, pageLimit } = data;
        // console.log('on page changed data',data);
        // console.log(data.currentPage === currentPage);

        const offset = (currentPage - 1) * pageLimit;
        const currentCountries = allCountries.slice(offset, offset + pageLimit);

        const currentSchedules = allSchedules.slice(offset, offset + pageLimit);

        this.setState({ currentPage, currentCountries, currentSchedules, totalPages });
    }

    showUserInfo(){
        let that = this;
        axios.get('https://spice-api.pearlfall.vercel.app'+`/users/getUser`, this.state)
            .then(function (response) {
                // console.log('show user info vvv',response);
                that.setState({
                    userId: response.data.id,
                    userType: response.data.type,
                }, ()=> {
                    that.getAcceptList();
                });
                // console.log('id vv', that.state.userId);
            })
            .catch(function (error) {
                console.log(error);
            })

    }



    async getAcceptList(){

        // console.log("what is id,,", this.state.userId);
        let that = this;
        let payload = {
            "userId": this.state.userId,
            "type": 'history',
        }
        await axios.post(this.state.userType === 'Seller' ?
            'https://spice-api.pearlfall.vercel.app'+`/requests/acceptedList/seller`
        :'https://spice-api.pearlfall.vercel.app'+`/requests/acceptedList/buyer`, payload)
            .then(function (response) {
                // console.log('response seller id', response);
                that.setState({
                    allSchedules: response.data.request
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        const { allCountries, currentCountries, allSchedules, currentSchedules, currentPage, totalPages } = this.state;

        // console.log('know state 2', this.state);
        // console.log('current countries', currentCountries);
        // console.log('all schedules', allSchedules);
        // console.log('all countries', allCountries);
        // const { allSchedules, currentSchedules, currentPage, totalPages } = this.state;

        // const totalCountries = allCountries.length;
        const totalSchedules = allSchedules.length;

        // console.log('total length', totalSchedules);

        // if (totalCountries === 0) return null;
        if (totalSchedules === 0) {
            return (
                <div className="profile-right">
                    <h1 className="text-center dashboard-title">You have not done any deal so far.</h1>
                </div>
            );
        }

        const headerClass = ['text-dark py-2 pr-4 m-0', currentPage ? 'border-gray border-right' : ''].join(' ').trim();

        return (
            <div className="profile-right">
                <h1 className="text-center dashboard-title">Here are past deals</h1>
                {/*<div className="container mb-5">*/}
                <div className="row d-flex flex-row" style={{"padding":"20px"}}>

                    <div className="w-100 py-5 d-flex flex-row flex-wrap align-items-center justify-content-between">
                        <div className="d-flex flex-row align-items-center">

                            <h2 className={headerClass}>
                                {/*<strong className="text-secondary">{totalCountries}</strong> deals*/}
                                <strong className="text-secondary"style={{"margin-left": "20px"}}>{totalSchedules}</strong> deals
                            </h2>

                            { currentPage && (
                                <span className="current-page d-inline-block h-100 pl-4 text-secondary">
                  Page <span className="font-weight-bold">{ currentPage }</span> / <span className="font-weight-bold">{ totalPages }</span>
                </span>
                            ) }

                        </div>

                        <div className="d-flex flex-row py-4 align-items-center">
                            {/*<Pagination totalRecords={totalCountries} pageLimit={6} pageNeighbours={1} onPageChanged={this.onPageChanged} />*/}
                            <Pagination totalRecords={totalSchedules} pageLimit={6} pageNeighbours={1} onPageChanged={this.onPageChanged} />
                        </div>
                    </div>

                    { currentSchedules.map((schedule,index) => <ScheduleCard key={index} schedule={schedule} type={'history'}/>) }
                    {/*id 가 없으므로 index를 key로 사용해서!!*/}
                    {/*{ currentSchedules.map(schedule => <ScheduleCard  user={schedule} />) }*/}


                </div>
                {/*</div>*/}
            </div>

        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user,
        // isAuthenticated: store.auth.isAuthenticated
    };
}


export default withRouter(connect(mapStateToProps)(History));
